import { put } from 'redux-saga/effects';
import { Types } from './actions';
import DateHelpers from '../../../../core/helpers/DateHelper';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.GET_WEEK_REQUEST });
    const { date } = action;
    const availableDays = [1, 2, 3, 4, 5, 6, 7];
    const firstDayOfWeek = DateHelpers.getFirstDayOfWeekFromTimestamp(
      date.getTime()
    );
    const dates = availableDays.map((numberDay: number) =>
      DateHelpers.addDays(new Date(firstDayOfWeek), numberDay - 1)
    );
    const today = DateHelpers.getPeruDate();
    const selectedDate = date;

    const data = { week: dates, today, selectedDate };
    yield put({ type: Types.GET_WEEK_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_WEEK_FAILURE,
      error: 'Ocurrió un error'
    });
    throw error;
  }
}
